import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../styles/Home.module.css';
import RegularButton from './CustomButtons/Button';
import MedineerLogin from './MedineerComponents/MedineerLogin';

function TestDetailsPage({ subscription, isLoggedIn, hideTestDetails, showSignUpForm }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const navigate = useNavigate();
    console.log(subscription, '-subscription')
    const [price, setPrice] = useState(subscription?.price ?? 0);
    const [showCheckout, setShowCheckout] = useState(false);
    const series = {
        "courseId": subscription?.subscriptionTypeId ?? subscription?.courseId,  //passing default as 1 for now
        "price": price ?? 0,
    }
    const onNextHandle = () => {
        let ResourceTypeId = 4;
        if (isLoggedIn === true) {
            setShowCheckout(true);
        } else {
            showSignUpForm();
            // setShowSignup(true);
            // navigate('/medineer/SignUp', { state: { series, ResourceTypeId } });
        }

    }
    const handleCloseModal = () => {
        hideTestDetails();
        setShowCheckout(false);

    }
    return (
        <div className={styles.knowYourCollegeContainer}>
            <div style={{ display: isMobile ? 'none' : 'block' }} className={styles.imageContainer}>
                <img src={'/CreateTests.png'} alt="Students discussing college predictor" />
            </div>
            <div className={styles.textContainer}>
                {
                    isMobile ?
                        <>
                            <h4>
                                <>Monthly Test Pack</>
                                <RegularButton
                                    round
                                    className={styles.signUpButtonMobile}
                                    onClick={() => onNextHandle()}
                                    style={isMobile ? null : { display: 'none' }}
                                // disabled={selectedItems.length === 0}
                                >
                                    {isLoggedIn === true ? "Next" : "Sign Up"}
                                </RegularButton>
                            </h4>
                        </>
                        :
                        <h3>Topic Pulse - Montly TopicWise Tests</h3>
                }
                <hr style={{ height: '4px', background: '#f8cb1e', margin: '10px 0' }} />
                <ul className={styles.detailsPoints}>

                    <li>Build your <b>own plan</b>—pick the <b>right test immediately</b> after mastering a topic.</li>
                    <li>Get instant <b>performance reviews </b>with detailed <b>solutions</b> and clear insights for every question.</li>
                    <li>Understand where to improve with clear,<b> topic-based analytics</b> and easy-to-read visual graphs.</li>
                    <li><b>Start</b> today—build <b>confidence</b> with focused <b>practice</b> and stay ahead of the competition.</li>
                    <li>Take charge of your <b>success journey</b> with on-demand tests aligned to your preparation.</li>

                </ul>
                <RegularButton
                    round
                    className={styles.signUpButton}
                    onClick={() => onNextHandle()}
                    // disabled={selectedItems.length === 0}
                    style={{ display: isMobile ? 'none' : 'block' }}

                >
                    {isLoggedIn === true ? "Next" : "Sign Up"}
                </RegularButton>

            </div>
            {
                showCheckout && <MedineerLogin
                    course={series}
                    ResourceTypeId={4}
                    closeModal={handleCloseModal}
                /> // ResourceTypeId have value 4 for subscription
            }
        </div>
    )
}

export default TestDetailsPage